export default {
  Codigo: null,
  Descripcion: '',
};
